/*************************************************/
/* ARTICLES SLIDER                               */
/*************************************************/
import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

export function articlesSlider() {
    document.querySelectorAll(".articles-list--slider").forEach(root => {
        const swiperEl = root.querySelector(".articles-list__slider");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            modules: [Navigation, Scrollbar],
            speed: 500,
            slidesPerView: 1.15,
            spaceBetween: 15,
            watchOverflow: true,
            navigation: {
                nextEl: root.querySelector(".articles-list__nav-btn--next"),
                prevEl: root.querySelector(".articles-list__nav-btn--prev"),
            },
            scrollbar: {
                el: root.querySelector(".articles-list__scrollbar"),
                draggable: true,
            },
            breakpoints: {
                667: {
                    slidesPerView: 2.15,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    });
}
